import r from "../managers/braze-instance.js";
import { InternalEventTypes as dr } from "../../shared-lib/index.js";
export function logFeedDisplayed() {
  var e;
  if (r.rr())
    return null === (e = r.g()) || void 0 === e ? void 0 : e.zr(dr.Fr).ss;
}
